import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle6() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article6" headerImage="lighteg.jpg" photographer=" Burak The Weekender" />
        <Footer />
    </div>
  )
}
